import React from "react";
import { render } from "react-dom";
import log from "../helpers/log";
import PlayVideo from "../helpers/PlayVideo";
import ResponsivePicture from "../helpers/ResponsivePicture.jsx";

class GamesFilterGamesLi extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		var $tags = [];
		this.props.tags.forEach((result, key) => {
			$tags.push(
				<div
					key={key}
					className={`gameThumbnail-status gameThumbnail-status--${result} s_${result}`}
				/>
			);
		});
		let clases = "gameThumbnail ";
		if (this.props.video) {
			clases += "hasVideo";
		}
		return (
			<li className={clases} itemScope="" itemType="https://schema.org/Game">
				<link
					itemProp="applicationCategory"
					content={this.props.applicationCategory}
				/>
				<meta itemProp="operatingSystem" content="Windows" />
				<meta itemProp="operatingSystem" content="OS X" />
				<meta itemProp="operatingSystem" content="Linux" />
				<meta itemProp="gamePlatform" content="WEB" />
				<span
					className="metatags"
					itemProp="aggregateRating"
					itemScope=""
					itemType="https://schema.org/AggregateRating"
				>
					<span hidden="" itemProp="ratingValue">
						{this.props.ratingValue}
					</span>
					<span hidden="" itemProp="ratingCount">
						{this.props.ratingCount}
					</span>
					<span hidden="" itemProp="reviewCount">
						{this.props.reviewCount}
					</span>
					<span hidden="" itemProp="worstRating">
						{this.props.worstRating}
					</span>
					<span hidden="" itemProp="bestRating">
						{this.props.bestRating}
					</span>
					<span hidden="" itemProp="price">
						0.00
					</span>
				</span>
				<a
					href={this.props.url}
					target={this.props.newWindow ? "_blank" : "_self"}
					itemProp="url"
				>
					<span className="gameThumbnail-tags">
						{$tags}

						{this.props.saga ? (
							<div className="Games-saga">{this.props.saga}</div>
						) : null}
					</span>
					<ResponsivePicture
						route={this.props.img}
						key={this.props.img}
						width="140"
						height="105"
						isRetina={window.isRetinadisplay}
					/>
					{this.props.video ? (
						<video
							src={this.props.video}
							loop
							preload="none"
							muted=""
							poster={window.cdns[0] + "public/images/spinners/loading-136.svg"}
							itemProp="trailer"
							itemType="https://schema.org/VideoObject"
							style={{
								backgroundSize: "140px 105px"
							}}
						>
							<source
								src={this.props.video}
								type="video/mp4"
								itemProp="contentUrl"
							/>
						</video>
					) : null}

					<div
						className={`gameThumbnail-description ${
							!this.props.puntuation
								? "gameThumbnail-description--whitoutnumber"
								: null
						}`}
					>
						<p className="Game-title" title={this.props.name} itemProp="name">
							{this.props.name}
						</p>
						{this.props.puntuation ? (
							<div
								className={
									"gameThumbnail-quality gameThumbnail-quality--" +
									this.props.puntuation[0]
								}
							>
								{this.props.puntuation[1]}
							</div>
						) : null}
					</div>
				</a>
			</li>
		);
	}
}

class GamesFilterGames extends React.Component {
	constructor(props) {
		super(props);
	}
	componentDidMount() {
		new PlayVideo();
	}
	componentWillUnmount() {
		$(".hasVideo").unbind();
	}
	shouldComponentUpdate() {
		$(".hasVideo").unbind();
		return true;
	}
	componentDidUpdate() {
		new PlayVideo();
	}
	render() {
		var rows = [];
		let relacionados = "";
		this.props.data.forEach((result, key) => {
			rows.push(<GamesFilterGamesLi key={key} {...result} />);
		});
		return (
			<div>
				<ul>{rows}</ul>
				<div
					id="relacionados"
					dangerouslySetInnerHTML={{ __html: this.props.relacionados }}
				/>
			</div>
		);
	}
}
export default GamesFilterGames;
